import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {
    CompanySettingModel,
    DailyTransactionTypeEnum,
    SystemModulesConfigurationModel,
    UserConfigurationModel,
    UserSettingModel,
    UserTransactionsSettingResponseModel
} from "../../models";
import {
    getCompanySettings,
} from "../../components/transactions/common/businessLogic/transactionBl";
import {getUserSetting, getUserTransactionsSettings} from "../../serviceBroker/userApiServiceBroker";
import {getUserId} from "../../utils";
import {SystemConfiguration} from "../../configuration";
import {getAllSystemLightModule} from "../../serviceBroker/systemConfigurationApiServiceBroker";
import {useGenericSystemConfigurations} from "./useGenericSystemConfigurations";
import {companySettingInitialValues,    userSettingInitialValues,userTransactionsSettingInitialValues} from "../../components/transactions/common/initialValues/initialValues";

export const useSystemConfigurations=(setLoading:Dispatch<SetStateAction<boolean>>,transactionType:DailyTransactionTypeEnum=DailyTransactionTypeEnum.None)=>{
    //#region state
    const [userSetting, setUserSetting] = useState<UserSettingModel>(userSettingInitialValues);
    const [companySetting,setCompanySetting]=useState<CompanySettingModel>(companySettingInitialValues)
    const [userTransactionSettingList, setUserTransactionSettingList] = useState<UserTransactionsSettingResponseModel[]>([]);
    const [systemModulesConfigurationList, setSystemModulesConfigurationList] = useState<SystemModulesConfigurationModel[]>([]);
    const [isTransactionLoaded, setIsTransactionLoaded] = useState(false);
    //#endregion
    //#region hooks
    const { genericSystemConfigurations, isConfigurationLoaded } = useGenericSystemConfigurations();
    //#endregion
    //#region useEffect
    useEffect(() => {
        const fillData = async () => {
            setLoading(true);
            await fillBasicDataPromiseAll();
            setLoading(false);
        };
        fillData().then(() => {
        });
    }, []);
    //#endregion
    //#region function
    const fillBasicDataPromiseAll = async () => {
        const [
            _userSetting,
            _userTransactionSettingList,
            _companySetting,
            _systemModulesConfiguration
        ] = await Promise.all([
            getUserSetting(getUserId()),
            getUserTransactionsSettings(
                [
                    DailyTransactionTypeEnum.SalesInvoice,
                    DailyTransactionTypeEnum.PurchasesInvoice,
                    DailyTransactionTypeEnum.SalesRefund,
                    DailyTransactionTypeEnum.PurchasesRefund,
                    DailyTransactionTypeEnum.Order,
                    DailyTransactionTypeEnum.ShowPrice,
                    DailyTransactionTypeEnum.POSSales,
                    DailyTransactionTypeEnum.POSSalesRefund,
                    DailyTransactionTypeEnum.POSRestaurant,
                    DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
                    DailyTransactionTypeEnum.ReturnPOSRestaurant,
                ],
                true,
                SystemConfiguration.cacheKey_Configurations.setting.userTransactionSettingsList
            ),
            getCompanySettings(),
            getAllSystemLightModule(),
        ]);
        setUserSetting(_userSetting??userSettingInitialValues);
        setUserTransactionSettingList(_userTransactionSettingList);
        setCompanySetting(_companySetting);
        setSystemModulesConfigurationList(_systemModulesConfiguration?.Result??[]);
        setIsTransactionLoaded(true);
    };
    //#endregion
    return {
        userConfiguration:{
            userSetting,
            companySetting,
            userTransactionSetting:transactionType===DailyTransactionTypeEnum.None?userTransactionsSettingInitialValues:userTransactionSettingList.find(x=>x.TransactionType_ID===transactionType)||userTransactionsSettingInitialValues,
            userTransactionSettings:userTransactionSettingList,
            systemModulesConfigurations:systemModulesConfigurationList,
            genericSystemConfigurations:genericSystemConfigurations,
        } as UserConfigurationModel,
        isTransactionLoaded,
    }
}